 const CONFIG = {
    APPLICATION_FEE: process.env.REACT_APP_APPLICATION_FEE,
    FLUTTERWAVE_SECRET_KEY: process.env.REACT_APP_FLUTTERWAVE_SECRET_KEY,
    FLUTTERWAVE_PUBLIC_KEY: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY,
    BASE_URL: process.env.REACT_APP_BASE_URL,
}
 
export default CONFIG;